export default __webpack_public_path__ + "static/media/happy home school logo.30d86bec.jfif";